import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Trans } from 'react-i18next';
import colors from 'hsl-shared-components/lib/Theme/colors';
import {
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_BREAKPOINT_IN_PX,
  LAPTOP_BREAKPOINT_IN_PX,
} from '../../constants';

const SelectorRow = styled.div`
  display: flex;
  align-items: left;
  flex-direction: column;
`;

const CurrentZoneText = styled.div`
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.5px;
  line-heigth: 24px;
  color: ${colors.primary.hslGreyDark};
  margin-bottom: 20px;

  @media screen and (max-width: ${LAPTOP_BREAKPOINT_IN_PX}px) {
    font-size: 18px;
    margin-bottom: 18px;
  }

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    font-size: 16px;
    margin-bottom: 10px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    font-size: 14px;
    line-heigth: 21px;
    padding-left: 20px;
    letter-spacing: -0.3px;
  }
`;

const ZoneSelector = styled.div`
  min-width: 120px;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    padding-left: 20px;
  }

  & > a {
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
      letter-spacing: -1.5px;
    }
  }
`;

// prettier-ignore
const Zone = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 45px;

  background: #27619C;
  border-radius: 50px;
  display: inline-block;
  color: ${colors.background.hslGreyXXLight};
  background-color: ${colors.primary.hslBlue};
  font-weight: 400;
  font-size: 18px;
  letter-spacing: -0.02em;
  position: relative;
  cursor: pointer;
  user-select: none;

  @media screen and (max-width: ${LAPTOP_BREAKPOINT_IN_PX}px) {
    width: 60px;
    height: 40px;
    margin-right: 0.5em;
    font-size: 14px;
  }

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    width: 50px;
    height: 30px;
    margin-right: 0.5em;
    font-size: 12px;
  }

  ${(props) => props.selected && css`
    background: ${colors.primary.hslBlueDark};
  `}

  &:hover {
    cursor: pointer;
    border-color: ${colors.primary.hslBlueDark};
  }

  & > span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-55%);

    @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
      transform: translateY(-50%) translateX(-52%);
    }
  }
`;

const CurrentZoneSelector = ({ currentZone, setCurrentZone }) => (
  <SelectorRow>
    <CurrentZoneText>
      <Trans i18nKey="Generic.currentZone" />
    </CurrentZoneText>
    <ZoneSelector>
      <Zone selected={currentZone === 'A'} onClick={() => setCurrentZone('A')}>
        <span>A</span>
      </Zone>
      <Zone
        selected={currentZone === 'B' || currentZone === 'B2'}
        onClick={() => setCurrentZone('B')}
      >
        <span>B</span>
      </Zone>
      <Zone
        selected={currentZone === 'C' || currentZone === 'C2'}
        onClick={() => setCurrentZone('C')}
      >
        <span>C</span>
      </Zone>
      <Zone
        selected={currentZone === 'D' || currentZone === 'D2'}
        onClick={() => setCurrentZone('D')}
      >
        <span>D</span>
      </Zone>
    </ZoneSelector>
  </SelectorRow>
);

CurrentZoneSelector.propTypes = {
  currentZone: PropTypes.string.isRequired,
  setCurrentZone: PropTypes.func.isRequired,
};

export default CurrentZoneSelector;
